export class Margins
{
  left:number = 0;
  right:number = 0;
  top:number = 0;
  bottom:number = 0;

  set horizontal( value:number )
  {
    this.left = value;
    this.right = value;
  } 

  set vertical( value:number )
  {
    this.top = value;
    this.bottom = value;
  } 

  set all( value:number )
  {
    this.horizontal = value;
    this.vertical = value;
  }

  get horizontalSum()
  {
    return this.left + this.right;
  }

  get verticalSum()
  {
    return this.top + this.bottom;
  }

  equals( other:Margins )
  {
    if ( ! other )
    {
      return false;
    }

    if ( other.left !== this.left || other.right !== this.right )
    {
      return false;
    }

    if ( other.top !== this.top || other.bottom !== this.bottom ) 
    {
      return false;
    }

    return true;

  }

  static readonly NoMargins = new Margins();
  static with( ...numbers:number[] )
  {
    let margins = new Margins();
    
    if ( numbers.length == 1 )
    {
      margins.all = numbers[ 0 ];
    }
    else if ( numbers.length == 2 )
    {
      margins.vertical = numbers[ 0 ];
      margins.horizontal = numbers[ 1 ];
    }
    else if ( numbers.length >= 4 )
    {
      margins.top = numbers[ 0 ];
      margins.right = numbers[ 1 ];
      margins.bottom = numbers[ 2 ];
      margins.left = numbers[ 3 ];
    }

    return margins;

  }
}